import React from 'react';
import { Link } from 'react-router-dom';

import ProfileDropdown from '../../Components/Common/ProfileDropdown';

const TOPBAR_HEIGHT = 64;

/**
 * Top bar — self-styled, no reliance on template's `#page-topbar` rules.
 * Sticks to the top of the scrolling content area; the sidebar (fixed) sits
 * to its left on desktop and slides in/out of frame on mobile.
 */
const Header = () => {
    const toggleMenuBtn = () => {
        const w = document.documentElement.clientWidth;

        if (w > 767) {
            document.querySelector(".hamburger-icon")?.classList.toggle('open');
        }

        if (w <= 767) {
            // Mobile: slide the sidebar in/out
            document.body.classList.toggle('vertical-sidebar-enable');
        } else if (w < 1025) {
            // Tablet: collapse to icon-only sidebar
            document.body.classList.remove('vertical-sidebar-enable');
            const size = document.documentElement.getAttribute('data-sidebar-size');
            document.documentElement.setAttribute('data-sidebar-size', size === 'sm' ? '' : 'sm');
        } else {
            // Desktop: toggle full vs collapsed sidebar
            document.body.classList.remove('vertical-sidebar-enable');
            const size = document.documentElement.getAttribute('data-sidebar-size');
            document.documentElement.setAttribute('data-sidebar-size', size === 'lg' ? 'sm' : 'lg');
        }
    };

    return (
        <header
            id="page-topbar"
            style={{
                position: "sticky",
                top: 0,
                zIndex: 100,
                height: TOPBAR_HEIGHT,
                background: "rgba(14, 13, 41, 0.78)",
                backdropFilter: "blur(14px)",
                WebkitBackdropFilter: "blur(14px)",
                borderBottom: "1px solid var(--bl-line)",
            }}
        >
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 1rem",
                    gap: "0.75rem",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", minWidth: 0 }}>
                    <button
                        type="button"
                        onClick={toggleMenuBtn}
                        id="topnav-hamburger-icon"
                        aria-label="Toggle navigation"
                        className="topnav-hamburger"
                        style={{
                            background: "transparent",
                            border: 0,
                            padding: "0.5rem 0.65rem",
                            color: "var(--bl-text-strong)",
                            borderRadius: "0.55rem",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <span className="hamburger-icon"><span></span><span></span><span></span></span>
                    </button>

                    <Link
                        to="/overview"
                        aria-label="BiorGov home"
                        style={{
                            textDecoration: "none",
                            fontFamily: "var(--bl-font-display)",
                            fontWeight: 700,
                            fontSize: "1.1rem",
                            letterSpacing: "-0.01em",
                            background: "linear-gradient(115deg, #ffffff 0%, #7B7CFF 70%, #3738C4 100%)",
                            WebkitBackgroundClip: "text",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            color: "transparent",
                        }}
                    >
                        BiorGov
                    </Link>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                    <ProfileDropdown />
                </div>
            </div>
        </header>
    );
};

export default Header;
